import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Headers, Http, RequestOptions } from '@angular/http';
import { EscolherDependentePage } from '../dependentes/escolherdependente';

@Component({
  selector: 'adddependente',
  templateUrl: 'adddependente.html'
})
export class AddDependentePage {
	public coord;
	public coord2;
	public coord3;
	public cidade;
	public cidade2;
	public cidade3;
	public estado;
	public estado2;
	public estado3;

	constructor(public navCtrl: NavController, public navParams: NavParams, private http: Http) {
		this.coord = navParams.get("coord");
		this.coord2 = navParams.get("coord2");
		this.coord3 = navParams.get("coord3");
   		this.cidade = navParams.get("cidade");
   		this.cidade2 = navParams.get("cidade2");
   		this.cidade3 = navParams.get("cidade3");
   		this.estado = navParams.get("estado");
   		this.estado2 = navParams.get("estado2");
   		this.estado3 = navParams.get("estado3");
	}

	addDependente(){
		var nome = (<HTMLInputElement>document.getElementById('nome')).value;
		var sexo = (<HTMLInputElement>document.getElementById('sexo')).value;
		var data = (<HTMLInputElement>document.getElementById('data')).value;
		var parentesco = (<HTMLInputElement>document.getElementById('parentesco')).value;

		if(nome == "" || sexo == "" || data == "" || parentesco == ""){
			document.getElementById("preencha").innerHTML = "Preencha todos os campos.";
		} else {
			let headers = new Headers();
	        headers.append("Accept", 'application/json');
	        headers.append('Content-Type', 'application/x-www-form-urlencoded' );
	        let options = new RequestOptions({ headers: headers });
	     	
	     	var postParams = JSON.stringify({
	        	nome: nome,
	        	sexo: sexo,
	        	data: data,
	        	parentesco: parentesco,
	        	idPai: localStorage.getItem('idUsuario')
	        });

			var link = 'http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/setDependente';
	        
			this.http.post(link, postParams, options).map(res => res.json())
        	.subscribe(
	            data => {
	          		this.navCtrl.push(EscolherDependentePage, {
						coord: this.coord,
						coord2: this.coord2,
						coord3: this.coord3,
						cidade: this.cidade,
						cidade2: this.cidade2,
						cidade3: this.cidade3,
						estado: this.estado,
						estado2: this.estado2,
						estado3: this.estado3
					});
	            },
	            err => {
	              console.log("ERROR!: ", err);
	            }
        	);
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/dependentes/adddependente.ts